import React from 'react';
import MockUserCreator from '../components/MockPosts/MockUserCreator';
import Box from '@mui/material/Box';

const NAVBAR_HEIGHT = 64;

const MockUsers: React.FC = () => (
  <Box
    sx={{
      position: 'fixed',
      top: `${NAVBAR_HEIGHT}px`,
      left: 0,
      right: 0,
      bottom: 0,
      bgcolor: '#f5f5f5',
      zIndex: 1,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: `calc(100vh - ${NAVBAR_HEIGHT}px)`
    }}
  >
    <MockUserCreator />
  </Box>
);

export default MockUsers; 